<template>
    <div>
        <div class="header-container" v-if="showLoading">
            <div class="logo-view"><img src="/logo.png" alt="" /></div>
        </div>
        <div class="content-container" v-if="!isError && showLoading">
            <i class="el-icon el-icon-time"></i>
            <div class="title-view">登录验证</div>
            <div class="desc-view">正在进行登录验证操作...</div>
        </div>
        <div class="content-container error" v-else>
            <i class="el-icon el-icon-warning-outline"></i>
            <div class="title-view">验证失败</div>
            <div class="desc-view">登录验证失败，请稍后再试</div>
        </div>
    </div>
</template>

<script>
import {UserService as ModuleUserService} from '@digital-supply-chain/module'
import {UtilService} from '@/libs/index';
import {UserService} from '@/service/index';

export default {
    data() {
        return {
            source: 'casi',
            urlPrams: {},
            isError: false,
        }
    },
    computed: {
        showLoading() {
            return this.source != 'token';
        }
    },
    mounted() {
        this.source = this.$route.params.source;
        this.urlParams = UtilService.getUrlParamObj();
        this[`${this.source}Login`]();
    },
    methods: {
        async tokenLogin() {
            const {token, redirect} = this.urlParams;
            if (!token) {
                alert('缺少token参数');
                return false;
            }
            try {
                const res = await UserService.GetTokenUserInfo(token);
                if (res) {
                    ModuleUserService.setUserOfBrowser(res || {});
                    window.location.replace(redirect ? decodeURIComponent(redirect) : '/');
                }
            } catch (error) {
                this.isError = true;
            }
        },
        async casiLogin() {
            const {code, scope} = this.urlParams;
            if (!code) {
                alert('缺少code参数');
                return false;
            }
            try {
                const res = await UserService.casiLogin(code, scope);
                if (res.code === 0) {
                    ModuleUserService.setUserOfBrowser(res.data || {});
                    window.location.replace('/');
                }
            } catch (error) {
                this.isError = true;
            }
        }
    },
}
</script>

<style lang="less" scoped>
    .header-container{
        background-color: #161823;
        width: 100%;
        height: 64px;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
    }
    .logo-view{
        width: 800px;
        height: 36px;
        margin: 0 auto;
        text-align: left;
        img{
            height: 100%;
        }
    }
    .content-container{
        width: 800px;
        margin: 0 auto;
        background: #ecf5ff;
        border: 1px solid #b3d8ff;
        border-radius: 8px;
        padding: 16px;
        margin-top: 40px;
        position: relative;
        padding-left: 62px;
        &.error{
            background: #fef0f0;
            border: 1px solid #f56c6c;
        }
        .el-icon{
            font-size: 38px;
            color: #909399;
            position: absolute;
            left: 16px;
            top: 16px;
        }
        .title-view{
            color: #303133;
            font-size: 16px;
            font-weight: bold;
        }
        .desc-view{
            color: #909399;
            font-size: 14px;
            margin-top: 6px;
        }
    }
</style>